import { GridColDef } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';
import { IEnergyAsset, IFacility, IPage } from 'common/src/types/interfaces';

import { NEW_ID } from 'portal/src/constants/ReservedIDs';

import {
  deleteEnergyAsset,
  getEnergyAssets,
} from '../../api/EnergyAssetsService';
import DataTable from '../common/DataTable';

const EnergyAssets = () => {
  const navigate = useNavigate();

  const {
    data: energyAssets,
    isFetching,
    isError,
    refetch,
  } = useQuery({
    queryKey: ['energyAssets'],
    queryFn: async () => await getEnergyAssets(),
    initialData: { data: [] } as IPage<IEnergyAsset>,
  });

  const gridColumns: GridColDef[] = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'siteLocation', headerName: 'Site Location', flex: 1 },
    { field: 'assetType', headerName: 'Asset Type', flex: 1 },
    { field: 'energyFlowType', headerName: 'Energy Flow Type', flex: 1 },
    { field: 'energyType', headerName: 'Energy Type', flex: 1 },
    { field: 'assetDescription', headerName: 'Asset Description', flex: 1 },
    {
      field: 'facility',
      headerName: 'Facility Association',
      minWidth: 100,
      flex: 1,
      valueGetter: (value: Partial<IFacility>) => {
        return value?.name ?? '';
      },
    },
  ];

  const handleNavigate = (id: string) => navigate(`./${id}`);

  return (
    <DataTable
      actionsConfig={{
        readActionConfig: {
          onClick: (id) => handleNavigate(id),
        },
        deleteConfig: {
          targetStr: 'energy asset',
          onDeleteClick: async (id) => {
            await deleteEnergyAsset(id);
            await refetch();
          },
          snackbarMsgKey: 'ENERGY_ASSET',
        },
      }}
      columns={gridColumns}
      contextName={NESTED_ROUTES.ADMINISTRATION.ENERGY_ASSETS}
      dataFetchError={isError}
      loading={isFetching}
      rows={energyAssets.data}
      toolbarSlotProps={{
        onNewButtonClick: () => handleNavigate(NEW_ID),
        exportFileName: 'energy_assets',
        showFilters: true,
      }}
    />
  );
};

export default EnergyAssets;
